module.exports = __webpack_public_path__ + "img/icon-diets.ea9693dd.jpg";